import _ from 'lodash'
import { ColumnType, TableProps } from './Table.component'
import { TableCell, TableRowItem, TagRowCell } from './Table.styles'
import { Fragment } from 'react'
import { Tokens } from '@/assets/tokens'

type CellProps<T> = {
  idx: number
  item: T
  column: ColumnType<T>
}

export function TableRowCell<T>({ idx, item, column }: CellProps<T>) {
  const value = _.get(item, column.key)

  return (
    <TableCell style={{ textAlign: column.align || 'left' }}>
      {column.render ? column.render(column, item, idx) : value}
    </TableCell>
  )
}

export function TableRows<T>({
  data,
  columns,
  disableRowStriping,
  renderRowTags,
  enableSelection = false,
  selectedItems,
  onItemSelect,
  getItemId,
}: TableProps<T>) {
  return (
    <>
      {data?.map((item, itemIndex) => {
        const rowKeySuffix = (item as any).id || itemIndex
        const isEvenLogicalRow = itemIndex % 2 === 0
        const rowBackgroundColor = isEvenLogicalRow || disableRowStriping ? Tokens.ColorWhite : '#f7f8fa'

        const itemId = getItemId ? getItemId(item) : (item as any).id
        const isSelected = selectedItems?.has(itemId) || false

        return (
          <Fragment key={`row-group-${rowKeySuffix}`}>
            <TableRowItem key={`data-row-${rowKeySuffix}`} style={{ backgroundColor: rowBackgroundColor }}>
              {enableSelection && (
                <TableCell style={{ width: '40px', paddingLeft: '8px', paddingRight: '8px', paddingBottom: '34px' }}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => onItemSelect?.(item)}
                    style={{ cursor: 'pointer' }}
                  />
                </TableCell>
              )}
              {columns.map((column) => (
                <TableRowCell key={`cell-${column.key}-${rowKeySuffix}`} item={item} column={column} idx={itemIndex} />
              ))}
            </TableRowItem>

            {renderRowTags && (
              <TableRowItem
                key={`tags-row-${rowKeySuffix}`}
                className="tags-sub-row"
                style={{
                  backgroundColor: rowBackgroundColor,
                }}>
                <TagRowCell colSpan={columns.length + (enableSelection ? 1 : 0)}>
                  {renderRowTags(item, itemIndex, columns)}
                </TagRowCell>
              </TableRowItem>
            )}
          </Fragment>
        )
      })}
    </>
  )
}
